import Axios from 'axios';

export const loginErrorHandler = (
  error: unknown,
): { error: true; errorPrimary: string; errorSecondary: string } => {
  if (error instanceof Error && error.message === 'nexmo error') {
    return {
      error: true,
      errorPrimary: 'SMS delivery failed. Please use ‘send code to email’.',
      errorSecondary: '',
    };
  }

  if (
    !Axios.isAxiosError(error) ||
    !error.response ||
    !error.response.data ||
    typeof error.response.data !== 'string'
  ) {
    window.rollbar?.error(`BuyersPortal: Failed to login. Unknown error.`, error as any);
    return {
      error: true,
      errorPrimary: 'Something went wrong',
      errorSecondary: 'Something went wrong',
    };
  }

  const data = error.response.data as string;

  if (data.includes('Invalid email address')) {
    return {
      error: true,
      errorPrimary: 'Enter a valid email (e.g. you@domain.com)',
      errorSecondary: '',
    };
  }

  // general validation messages
  if (data.includes('Invalid password')) {
    return {
      error: true,
      errorPrimary: '',
      errorSecondary: 'Invalid email or password',
    };
  }

  if (data === 'User / Password combination not found') {
    return {
      error: true,
      errorPrimary: '',
      errorSecondary: 'Invalid email or password',
    };
  }

  if (data.includes(`Invalid phone`)) {
    return {
      error: true,
      errorPrimary: 'No phone linked to this email',
      errorSecondary: '',
    };
  }

  if (data === 'User not active') {
    return {
      error: true,
      errorPrimary: 'Your account is not active',
      errorSecondary: '',
    };
  }

  // OTP validation messages
  if (data === 'unknown email') {
    return {
      error: true,
      errorPrimary: 'New here? Register!',
      errorSecondary: '',
    };
  }

  if (data === 'Wrong code') {
    return {
      error: true,
      errorPrimary: 'Invalid code',
      errorSecondary: '',
    };
  }

  if (data === 'Code expired') {
    return {
      error: true,
      errorPrimary: 'Expired code',
      errorSecondary: '',
    };
  }

  return {
    error: true,
    errorPrimary: data,
    errorSecondary: data,
  };
};
